import { useEffect, useState, useCallback } from "react";
import { getHealthApiBase } from "./constants/healthApi";

export default function useApi(url, options = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_URL = getHealthApiBase();

  const fetchApiData = useCallback(async () => {
    if (!url) return;

    setLoading(true);
    const controller = new AbortController();

    try {
      const response = await fetch(`${BASE_URL}${url}`, {
        method: "GET",
        signal: controller.signal,
        ...options,
      });

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const json = await response.json();

      // Optional special-case logic
      if (url.includes("RMPWidgetServicesView")) {
        setData({
          ...json,
          Network: 100,
          Infrastructure: 100,
        });
      } else {
        setData(json);
      }

      setError(null);
    } catch (err) {
      if (err.name !== "AbortError") {
        setError(err);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [url]);

  //  Fetch ONCE on component mount
  useEffect(() => {
    fetchApiData();
  }, [fetchApiData]);

  //  Expose manual refresh
  return { data, loading, error, refetch: fetchApiData };
}
//  import { useEffect, useState } from "react";
// export default function useApi(url, deps = [], options = {}) {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const BASE_URL =
//     "https://xbzpe5g7i2ibwqyuwlw2uszjva0zhtqq.lambda-url.us-east-1.on.aws";

//   useEffect(() => {
//     if (!url) return;

//     let isMounted = true;
//     const controller = new AbortController();
//     const signal = controller.signal;

//     const fetchApiData = async () => {
//       setLoading(true);

//       const timeout = setTimeout(() => controller.abort(), 10000); // 10 sec timeout

//       try {
//         const response = await fetch(`${BASE_URL}${url}`, {
//           method: "GET",
//           signal,
//           ...options,
//         });

//         clearTimeout(timeout);

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const json = await response.json();

//         if (isMounted) {
//           // ✅ Your special-case logic preserved
//           if (url.includes("RMPWidgetServicesView")) {
//             const finalData = {
//               ...json,
//               Network: 100,
//             };
//             setData(finalData);
//           } else {
//             setData(json);
//           }

//           setError(null);
//         }
//       } catch (err) {
//         if (isMounted && err.name !== "AbortError") {
//           setError(err);
//         }
//       } finally {
//         if (isMounted) {
//           setLoading(false);
//         }
//       }
//     };

//     // Initial Fetch
//     fetchApiData();

//     // Poll every 5 minutes
//     const interval = setInterval(fetchApiData, 300000);

//     return () => {
//       isMounted = false;
//       clearInterval(interval);
//       controller.abort();
//     };
//   }, [url, ...deps]);

//   return { data, loading, error };
// }